import { render, staticRenderFns } from "./ClientListProps.vue?vue&type=template&id=e16a3d64&scoped=true&"
import script from "./ClientListProps.vue?vue&type=script&lang=js&"
export * from "./ClientListProps.vue?vue&type=script&lang=js&"
import style0 from "./ClientListProps.vue?vue&type=style&index=0&id=e16a3d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16a3d64",
  null
  
)

export default component.exports